module.exports = __webpack_public_path__ + "media/images/countrysquared/gl-f25edb63a6747fbd358d002f2070a635.svg";